<template>
    <div id="StandardDefectsList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Standard Defect List</div>
                    <router-link v-if="canAddStandardDef" class="btn btn-primary pull-right" v-bind:to="{name: 'StandardDefectCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content standard-defect-list">
                        <data-table-filter-config :moduleName="'stDefectList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'stDefectList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        ref="listStandardDefectsTable"
                                        mode="remote"
                                        title="Standard Defects"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                        :select-options="{
                                    enabled: standard_defect_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                        :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateStandardDef">
                                                    <router-link title="Edit Standard Defects" class="fp-edit" v-bind:to="{name: 'StandardDefectEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="standard_defect_value" id="deleteStandardDefectTypeBtn" v-on:click.prevent="StandardDefectDelete" class="btn btn-danger">Delete</button>
                                    </div>

                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";

    
    
    import EventBus from "././event-bus";


    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "StandardDefectList",
        metaInfo() {
            return {title: "Standard Defect List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Department',
                    field: 'department_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            standard_defect_value: false,
            loading:false,
            canAddStandardDef:false,
            canUpdateStandardDef:false,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;

                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        // console.log(permissions[i].name);
                        if (permissions[i].name == 'list_standard_defect') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_standard_defect') {
                            self.canAddStandardDef = true;
                            self.canUpdateStandardDef = true;
                        }
                        if (permissions[i].name == 'delete_standard_defect') {
                            self.standard_defect_value = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            // self.loadList();
            self.getPermissions();
        },
        methods: {
          cancelAll: function (cancelAll) {
              this.$refs.listStandardDefectsTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/standard-defect/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'std-defect-list')
                    }
                });
            },
            StandardDefectDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Standard Defect?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listStandardDefectsTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listStandardDefectsTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteStandardDefectTypeBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/standard-defect/delete",
                          type: "POST",
                          data: 'id=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                                  $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteStandardDefectTypeBtn").val("Delete");
                              }, 10000);
                              // self.rows = data.content.row;
                              if (data.code == '200') {
                                  // self.rows = data.content.row;
                                  // self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,true,'std-defect-delete')
                          }
                      });
                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Standard Defect? ')) {
                // }
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/StandardDefectList.vue